import React from "react";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { notificationReducer, notificationSliceName } from "./redux/slice";
import notificationSaga from "./redux/saga";
import NotificationList from "app/containers/Features/containers/TeamSettings/container/Notification/NotificationList";

const Notification = () => {
  useInjectReducer({
    key: notificationSliceName,
    reducer: notificationReducer,
  });
  useInjectSaga({ key: notificationSliceName, saga: notificationSaga });

  return (
    <div className="flex flex-col gap-2 px-6">
      <NotificationList />
    </div>
  );
};

export default Notification;
